<script setup lang="ts">
import { useListRelinkableCompanies } from '@swipe4work/api-orval'

const props = withDefaults(defineProps<{
  modelValue?: number | null
  inputId?: string
  invalid?: boolean
  showClear?: boolean
  placeholder?: string
  disabled?: boolean
}>(), {
  modelValue: null,
  showClear: true,
  placeholder: 'Selecteer bestaand bedrijf',
  invalid: false,
  disabled: false,
})

const emit = defineEmits<{
  (e: 'update:modelValue', v: number | null): void
}>()

const { data, isPending } = useListRelinkableCompanies({ query: { staleTime: 5 * 60 * 1000 } })

const companies = computed(() => data.value?.companies ?? [])

const formatDate = (d: Date | string | null | undefined) => {
  if (!d) return null

  return new Intl.DateTimeFormat('nl-NL', { dateStyle: 'short' }).format(new Date(d))
}

const selected = computed({
  get: () => props.modelValue,
  set: v => emit('update:modelValue', v),
})
</script>

<template>
  <Select
    v-model="selected"
    :input-id="inputId"
    :options="companies"
    option-label="name"
    option-value="id"
    :invalid="invalid"
    :loading="isPending"
    :disabled="disabled"
    :placeholder="placeholder"
    :show-clear="showClear"
    filter
    filter-placeholder="Zoek bedrijf"
    class="w-full"
  >
    <template #option="{ option }">
      <div class="flex flex-col gap-0.5">
        <div class="flex items-center gap-2">
          <span class="text-sm">{{ option.name }}</span>
          <Tag v-if="option.exactCompanyName" value="Exact gekoppeld" severity="info" />
        </div>
        <span v-if="formatDate(option.deletedAt)" class="text-xs text-surface-400">
          Verwijderd op {{ formatDate(option.deletedAt) }}
        </span>
      </div>
    </template>
  </Select>
</template>
